// qs.stringify(..., { arrayFormat: 'repeat' }) 等價替代，使用原生 URLSearchParams
export const serializeParams = (params) => {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null) usp.append(key, v);
      });
    } else {
      usp.append(key, value);
    }
  });
  return usp.toString();
};

export const toFormUrlEncoded = (obj) => serializeParams(obj);
